import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from 'js.cookie';
import $ from 'jquery';
import { BrowserUpdate } from '@everfi/reactifi/src/browserUpdate';
import { ProgressSpinner } from '@everfi/reactifi/src/components/progress-spinner';
import { injectCustomerColorsCSS } from 'lib/utility/helpers';
import * as learnerDashboardActions from '../actions/learnerDashboardActions';
import { clearMessages } from '@everfi/reactifi';
import mapStateToProps from '../store/learnerDashboardMapper';
import OtherPlaylists from '../components/OtherPlaylists';
import Playlist from '../components/Playlist';
import GatewayModal from '../components/GatewayModal';
import Diagnostic from '../../../components/diagnostic';
import GenericModal from 'lib/components/GenericModal';
import NextStepsPanel from '../components/NextStepsPanel';
import { completedContentId, withPanelReturnUrl } from '../services/nextSteps';
import DashboardCustomization from '../components/DashboardCustomization';
import LoginBox from '../../../components/login_box';
import { Button } from 'reactifi';
import i18n from 'lib/utility/i18n';
import { getGatewayPromptCounts } from '../../../common/functions';
import { FROM_LIBRARY_QUERY_STRING } from '../../../common/constants';
import isEqual from 'lodash/isEqual';
import { sanitizeUrl } from '@braintree/sanitize-url';

const HEAP_RULE_SETS = ['pii_restricted_next_learner', 'next_learner'];

class LearnerDashboardContainer extends React.Component {
  static propTypes = {
    bypassRecaptcha: PropTypes.bool,
    currentUriContext: PropTypes.string.isRequired,
    dashboardCustomization: PropTypes.shape({
      enabled: PropTypes.bool,
      text: PropTypes.string,
    }),
    dashboardCustomizationId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    diagnostic: PropTypes.object,
    diagnosticId: PropTypes.number,
    gateways: PropTypes.array,
    incentiveId: PropTypes.string,
    locales: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        current: PropTypes.bool,
      })
    ),
    // organization_uuid: PropTypes.string,
    personalizedPlaylistId: PropTypes.number,
    playlist: PropTypes.object,
    playlistId: PropTypes.number,
    program: PropTypes.shape({
      auth_capabilities: PropTypes.object,
      account: PropTypes.shape({
        remind_playlist: PropTypes.bool,
        playlist_certificate_enabled: PropTypes.bool,
      }),
      custom_login_text: PropTypes.string,
      diagnostics: PropTypes.array,
      hide_header_login_button: PropTypes.bool,
      id: PropTypes.string,
      playlists: PropTypes.array,
      primary_color: PropTypes.string,
      remove_content_images: PropTypes.bool,
      secondary_color: PropTypes.string,
      slug: PropTypes.string,
    }),
    programId: PropTypes.number.isRequired,
    ui: PropTypes.shape({
      answers: PropTypes.array,
      authUrls: PropTypes.array,
      closedContent: PropTypes.string,
      foundryLinkUrl: PropTypes.string,
      loginText: PropTypes.string,
    }).isRequired,
    certificateServiceUrl: PropTypes.string,
    // adminifiUrl: PropTypes.string,
    jwt: PropTypes.string,
    facebookAppId: PropTypes.string,
    successMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    user: PropTypes.shape({
      id: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
      foundry_id: PropTypes.string,
      impersonatorId: PropTypes.string,
      guest: PropTypes.bool,
      ruleSets: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          active: PropTypes.bool,
        })
      ),
    }),
  };

  constructor(props) {
    super(props);

    this.state = { showLoginModal: false };
    this.actions = bindActionCreators({ ...learnerDashboardActions, clearMessages }, this.props.dispatch);
  }

  openLoginModal = (e) => {
    e.preventDefault();
    this.setState({ showLoginModal: true });
  };

  closeLoginModal = () => {
    this.setState({ showLoginModal: false });
  };

  async componentDidMount() {
    BrowserUpdate();

    const { dashboardCustomizationId, diagnosticId, personalizedPlaylistId, playlistId, programId, user } = this.props;

    await this.actions.selectProgram(programId);

    this.checkAndRedirectToLibrary(this.props.program?.slug);

    if (dashboardCustomizationId) {
      this.actions.loadCustomization(dashboardCustomizationId);
    }

    if (playlistId) {
      await this.actions.loadPlaylistItems(playlistId);
      this.actions.loadUserContent(programId, user?.id);
    } else if (personalizedPlaylistId) {
      await this.actions.loadPersonalizedPlaylistItems(personalizedPlaylistId);
      this.actions.loadUserContent(programId, user?.id);
    } else if (diagnosticId) {
      await this.actions.selectDiagnostic(diagnosticId);
      this.setDiagnosticStatus('pending');
    }

    await this.actions.loadIncentives(programId, playlistId);

    this.actions.loadOtherPlaylists(programId);
    this.actions.loadOtherDiagnostics(programId);

    await this.actions.loadGateways(programId, getGatewayPromptCounts());

    if (this.props.ui.closedContent) {
      Cookies.remove('closed_content_id');
      this.closedContentGatewayPending = true;
    }

    this.selectLoadedGateways();
  }

  /*
    react-redux v4 propagates store updates via setState from a store subscription. Under React
    18's createRoot that setState is automatically batched, so the re-render lands a microtask
    after the `await` above and this.props.gateways is still empty on the next line. Select the
    gateway once it has actually arrived in props instead.
  */
  selectLoadedGateways = () => {
    if (this.gatewaysSelected || !this.props.gateways.length) return;
    this.gatewaysSelected = true;

    this.handleDashboardLoadGateways();

    if (this.closedContentGatewayPending) {
      this.handleAfterContentGateways();
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.gateways !== prevProps.gateways) {
      this.selectLoadedGateways();
    }
    if (this.props.program && !isEqual(this.props.program, prevProps.program)) {
      injectCustomerColorsCSS(this.props.program.primary_color, this.props.program.secondary_color);
    }
    if (!!this.props.incentiveId && (!prevProps.incentiveId || prevProps.incentiveId !== this.props.incentiveId)) {
      this.actions.loadAllIncentiveActivities(this.props.programId, this.props.user?.id);
    }
    if (!!this.props.playlist && (!prevProps.playlist || prevProps.playlist !== this.props.playlist)) {
      const { playlist, user } = this.props;

      const learnerRuleSets = user.ruleSets?.filter(ruleSet => ruleSet.learner);

      if (window.heap && !user?.guest && HEAP_RULE_SETS.includes(learnerRuleSets[0].name)) {
        const userProperties = {
          Role: learnerRuleSets[0].name,
          [`PlayList ${playlist.id}`]: `${playlist?.name} - ${playlist?.allCompleted ? 'Completed' : 'Started'}`,
          ...(playlist?.content?.length &&
            playlist.content.reduce((acc, content) => {
              if (content?.user_content?.completed_at) {
                acc[`Module ${content.user_content.id} Completed`] = content.user_content.completed_at;
              } else if (content?.user_content?.started_at) {
                acc[`Module ${content.user_content.id} Started`] = content.user_content.started_at;
              }
              return acc;
            }, {})),
        };

        window.heap.addUserProperties(userProperties);
      }
    }
  }

  checkAndRedirectToLibrary = programSlug => {
    if (!programSlug) return;

    const urlParams = new URLSearchParams(window.location.search);
    const shouldRedirectToLibrary = Boolean(urlParams.get(FROM_LIBRARY_QUERY_STRING));

    if (shouldRedirectToLibrary) {
      urlParams.delete(FROM_LIBRARY_QUERY_STRING);
      window.location = sanitizeUrl(`/student/dashboard/${programSlug}/content_library?${urlParams.toString()}`);
    }
  };

  goToStudentUrl = content => {
    window.location = sanitizeUrl(`${this.props.currentUriContext}/${content.id}${window.location.search}`);
  };

  handleAfterContentGateways = () => this.setGateway('playlist:afterContentReturn');
  handleBeforeContentGateways = onGatewayFinished => this.setGateway('playlist:beforeContentStart', onGatewayFinished);
  handleDashboardLoadGateways = () => this.setGateway('dashboard:load');
  handleIncentiveCompleteGateways = onGatewayFinished => this.setGateway('incentive:complete', onGatewayFinished);

  setGateway = (gatewayAt, onGatewayFinished = () => {}) => {
    const { gateways } = this.props;
    if (gateways.length > 0) {
      const gateway = gateways.find(gateway => gateway.at === gatewayAt);
      if (gateway) {
        this.setState({ gateway, onGatewayFinished });
      } else {
        onGatewayFinished();
      }
    } else {
      onGatewayFinished();
    }
  };

  closeGateway = () => {
    const { gateway, onGatewayFinished } = this.state;
    if (gateway?.next) {
      const nextGateway = this.props.gateways.find(gw => gw.type === gateway.next);
      if (nextGateway) {
        this.setState({ gateway: nextGateway });
      } else {
        this.setState({ gateway: null, onGatewayFinished: null }, onGatewayFinished);
      }
    } else {
      this.setState({ gateway: null, onGatewayFinished: null }, onGatewayFinished);
    }
  };

  handleContentNav = content => {
    this.handleBeforeContentGateways(() => this.goToStudentUrl(content));
  };

  setDiagnosticStatus = diagnosticStatus => {
    if (diagnosticStatus === 'pending') {
      $('.footer').addClass('survey-pending'); // open survey footer visibility so people can change languages
    }
    this.setState({ diagnosticStatus });
  };

  render() {
    const { dashboardCustomization, diagnostic, program, playlist, ui, user } = this.props;
    const { diagnosticStatus } = this.state;
    const isGuest = !!user?.guest;

    if (!program) return <ProgressSpinner />;

    if (completedContentId()) {
      return (
        <div className="learner-dash-container primary secondary">
          <NextStepsPanel
            currentUriContext={this.props.currentUriContext}
            isGuest={isGuest}
            onLogin={program.hide_header_login_button ? undefined : this.openLoginModal}
            playlist={playlist}
            programId={program.id}
            programSlug={program.slug}
          />
          {isGuest && this.state.showLoginModal && (
            <GenericModal onClose={this.closeLoginModal} modalClass="login-reg-modal" canClose={true}>
              <LoginBox
                loginText={program.custom_login_text}
                programId={program.id}
                authCaps={program.auth_capabilities}
                authUrls={withPanelReturnUrl(ui.authUrls)}
                program={program}
              />
            </GenericModal>
          )}
        </div>
      );
    }

    if (diagnostic && diagnosticStatus === 'pending') {
      return (
        <GenericModal
          canClose={false}
          fullscreen={true}
          locales={this.props.locales}
          logo={null}
          modalClass="diagnostic"
          show={true}
          showMenu={true}
        >
          <Diagnostic
            diagnostic={diagnostic}
            containerSelector="diagnostic"
            setDiagnosticStatus={this.setDiagnosticStatus}
          />
        </GenericModal>
      );
    } else if (playlist || diagnosticStatus === 'failed') {
      return (
        <div className="learner-dash-container primary secondary">
          <Playlist
            key="playlists"
            diagnostic={diagnostic}
            handleContentNav={this.handleContentNav}
            handleIncentiveCompleteGateways={this.handleIncentiveCompleteGateways}
            playlist={playlist}
            program={program}
            setDiagnosticStatus={this.setDiagnosticStatus}
            awardSharingPlaylist={this.actions.awardSharingPlaylist}
            loadUserPlaylist={this.actions.loadUserPlaylist}
            getUserPlaylists={this.actions.getUserPlaylists}
            certificateServiceUrl={this.props.certificateServiceUrl}
            jwt={this.props.jwt}
            foundryId={this.props.user?.foundry_id}
            setReminder={program?.account?.remind_playlist ? this.actions.setReminder : undefined}
            playlistCertificateEnabled={program?.account?.playlist_certificate_enabled}
            errorMessage={this.props.errorMessage}
            successMessage={this.props.successMessage}
            clearMessages={this.actions.clearMessages}
            bypassRecaptcha={this.props.bypassRecaptcha}
            facebookAppId={this.props.facebookAppId}
          />
          {isGuest && !program.hide_header_login_button && (
            <div className="login-banner">
              <span className="login-banner-text">{i18n.t('Log in to save your progress and pick up where you left off')}</span>
              <Button className="login-banner-btn" onClick={this.openLoginModal} data-action="open-login-modal">{i18n.t('Log In')}</Button>
            </div>
          )}
          {isGuest && this.state.showLoginModal && (
            <GenericModal onClose={this.closeLoginModal} modalClass="login-reg-modal" canClose={true}>
              <LoginBox
                loginText={program.custom_login_text}
                programId={program.id}
                authCaps={program.auth_capabilities}
                authUrls={ui.authUrls}
                program={program}
              />
            </GenericModal>
          )}
          <div className="row">
            <div className="border-bottom" />
          </div>
          <div className="row other-playlists-row">
            <OtherPlaylists program={program} currentPlaylistId={playlist ? playlist.id : 0} />
          </div>
          {playlist && this.state.gateway && (
            <GatewayModal
              answers={ui.answers}
              authUrls={ui.authUrls}
              foundryLinkUrl={ui.foundryLinkUrl}
              gatewayToPresent={this.state.gateway}
              loginText={this.props.program.custom_login_text}
              onModalClose={this.closeGateway}
              programAuthCaps={program.auth_capabilities}
              programId={program.id}
            />
          )}
          <DashboardCustomization customization={dashboardCustomization} program={program} />
        </div>
      );
    } else {
      return <ProgressSpinner />;
    }
  }
}

export default connect(mapStateToProps)(LearnerDashboardContainer);
